<template>
  <div class="add">
    <div class="addHead el-row--flex">
      <el-button size="mini" @click="openEdit">
        <i class="el-icon-plus"></i>
        新增
      </el-button>
    </div>
    <el-form :inline="true" size="mini" :model="filter" class="demo-form-inline">
      <el-form-item label="投保人">
        <el-input v-model="filter.insureName"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filter.status">
          <el-option :label="$global.insuranceStatusStr(item)" :value="item" v-for="(item, index) in ['', 0, 1, 2, 3]"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" height="700" size="mini" :border="true">
      <el-table-column label="序号" type="index" min-width="64">
      </el-table-column>
      <el-table-column width="100px" label="电子保单">
        <template slot-scope="scope">
          <el-link v-if="scope.row.status == 1 && scope.row.status == 3" type="primary" target="_blank"
            :href="'/sywl/api/insuranceInfo/imgDetail/' + scope.row.insuranceId">预览</el-link>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="投保时间">
        <template slot-scope="scope">
          {{ $global.format(scope.row.createTime, 'yyyy-MM-dd') }}
        </template>
      </el-table-column>
      <el-table-column width="100px" label="投保状态">
        <template slot-scope="scope">
          {{ $global.insuranceStatusStr(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column width="100px" label="支付方式">
        <template slot-scope="scope">
          {{ scope.row.payType == 1 ? '线下支付' : '线上支付' }}
        </template>
      </el-table-column>
      <el-table-column min-width="200" label="保险名称">
        <template slot-scope="scope">
          {{ scope.row.insuranceName }}
        </template>
      </el-table-column>
      <el-table-column min-width="200" label="投保人名称">
        <template slot-scope="scope">
          {{ scope.row.insureName }}
        </template>
      </el-table-column>
      <el-table-column width="160px" label="保障起始日期">
        <template slot-scope="scope">
          {{ scope.row.startTime }}{{ scope.row.startTime || scope.row.endTime ? '~' : '' }}{{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100px" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length" @current-change="pageChange"  @size-change="handleSizeChange"></el-pagination>
    <el-dialog :title="isUpdate ? '修改' : '新增'" :visible.sync="addShow" width="1000px" :before-close="addClose">
      <el-form :model="addParam" size="mini" :rules="addRule" ref="add" label-width="80px">
        <el-descriptions :column="3" title="投保信息">
          <el-descriptions-item label="保险名称">
            <el-select v-model="addParam.insuranceId1" placeholder="请选择" size="small" @change="insurance1Change"
              :disabled="isUpdate">
              <el-option v-for="item in insuranceList" :key="item.insuranceId" :label="item.insuranceName"
                :value="item.insuranceId">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="总金额">
            <el-tag type="danger" size="small">￥{{ addSum.toFixed(2) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="生效周期">
            <el-tag type="danger" size="small">T+1</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="支付方式">
            <el-switch v-model="addParam.payType" :disabled="isUpdate" active-color="#13cbce" inactive-color="#13ce66"
              :active-value="1" :inactive-value="0" active-text="线下付款" inactive-text="线上付款">
            </el-switch>
          </el-descriptions-item>
        </el-descriptions>
        <div class="el-descriptions">
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">{{ addParam.payType == 1 ? '开票信息' : '投保人信息' }}</div>
          </div>
          <div class="el-descriptions__body">
            <el-row>
              <el-col :span="8">
                <el-form-item label="投保人" prop="insureName">
                  <el-input v-model="addParam.insureName" placeholder="请输入" :disabled="isUpdate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系电话" prop="insurePhone">
                  <el-input v-model="addParam.insurePhone" maxlength="11" placeholder="请输入" :disabled="isUpdate">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件号" prop="insureCard">
                  <el-input v-model="addParam.insureCard" maxlength="18" placeholder="请输入" :disabled="isUpdate">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="addParam.payType == 1">
              <el-col :span="8">
                <el-form-item label="开票电话" prop="payeePhone">
                  <el-input v-model="addParam.payeePhone" placeholder="请输入" :disabled="isUpdate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开户行" prop="payeeBankName">
                  <el-input v-model="addParam.payeeBankName" placeholder="请输入" :disabled="isUpdate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号" prop="payeeAccount">
                  <el-input v-model="addParam.payeeAccount" placeholder="请输入" :disabled="isUpdate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="详细地址" prop="payeeAddress">
                  <el-input v-model="addParam.payeeAddress" placeholder="请输入" :disabled="isUpdate"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="el-descriptions">
          <div class="el-descriptions__header">
            <div class="el-descriptions__title">被保人信息</div>
            <div class="el-descriptions__extra">
              <el-upload v-if="!isUpdate" class="upload-demo" ref="upload" action=""
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :before-upload="recognizeeImp" :auto-upload="true">
                <el-button size="mini" type="text" @click.stop="downloadMode">下载导入模板</el-button>
                <el-button size="mini" type="text" slot="trigger" style="margin: 0 10px;">导入</el-button>
                <el-button size="mini" type="text" @click.stop="recognizeeEdit()">添加</el-button>
              </el-upload>
            </div>
          </div>
          <div class="el-descriptions__body">
            <el-table :data="addData" :border="true" size="mini" :maxHeight="300">
              <el-table-column width="120px" label="被保人">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.insuredName" size="mini" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="130px" label="手机号码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.insuredPhone" size="mini" maxlength="11" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="证件号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.insuredCard" size="mini" maxlength="18" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column width="180px" label="职位 - 保额">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.levelId" placeholder="请选择" size="mini"
                    @change="levelChange(scope.$index)" :disabled="isUpdate">
                    <el-option v-for="item in levelList" :key="item.levelId"
                      :label="item.levelName + ' - ' + item.guaranteeAmount" :value="item.levelId">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="保费">
                <template slot-scope="scope">
                  {{ scope.row.insuranceAmount }}
                </template>
              </el-table-column>
              <el-table-column fixed="right" width="100px" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" v-if="isUpdate" @click="recognizeeEdit(scope.row)">保存</el-button>
                  <el-button type="text" size="mini" v-if="addData.length != 1 && !isUpdate"
                    @click="recognizeeDelete(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!isUpdate">
        <el-row justify="space-between">
          <el-col :span="12" style="text-align: left;">
            {{ addData.length }}条
          </el-col>
          <el-col :span="12">
            <el-button size="mini" @click="addShow = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="save">确 定</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    data() {
      return {
        filter: {
          insureName: '',
          insuredName: '',
          status: ''
        },
        tableData: [],
        currentPage: 1,
        pageSize: '10',
        addShow: false,
        isUpdate: false,
        addSum: 0,
        addParam: {
          insureId: '',
          insuranceId: '',
          payType: 0,
          insureName: '',
          insureCard: '',
          insureEmail: '',
          payeePhone: '',
          payeeBankName: '',
          payeeAccount: '',
          payeeAddress: '',
        },
        addRule: {
          insuranceId: [{
            required: true,
            message: '保险名称不能为空',
            trigger: 'blur'
          }],
          insureName: [{
            required: true,
            message: '投保人不能为空',
            trigger: 'blur'
          }],
          insureCard: [{
            required: true,
            message: '证件号不能为空',
            trigger: 'blur'
          }],
          insurePhone: [{
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          }, ],
          payeePhone: [{
            required: true,
            message: '开票电话不能为空',
            trigger: 'blur'
          }, ],
          payeeBankName: [{
            required: true,
            message: '开户行不能为空',
            trigger: 'blur'
          }, ],
          payeeAccount: [{
            required: true,
            message: '账号不能为空',
            trigger: 'blur'
          }, ],
          payeeAddress: [{
            required: true,
            message: '详细地址不能为空',
            trigger: 'blur'
          }, ]
        },
        insuranceList: [],
        levelList: [],
        fileList: [],
        addData: [],
        addDefaultData: [],
      }
    },
    mounted() {
      this.refresh();
    },
    watch: {
      addShow(n) {
        if (n) {
          this.$global.axios.post(this, '/sywl/api/insuranceList', {}, res => {
            this.insuranceList = res.data;
          })
          if (this.addParam.insuranceId) {
            this.recognizeeRefresh()
          }
        } else {
          this.addParam = {
            insureId: '',
            insuranceId: '',
            payType: 0,
            insureName: '',
            insureCard: '',
            insurePhone: '',
            payeePhone: '',
            payeeBankName: '',
            payeeAccount: '',
            payeeAddress: '',
          }
          this.addData = []
          this.addDefaultData = []
        }
      },
      'addParam.payType': {
        handler(n) {
          if (n != 1) {
            this.addParam.payeePhone = ''
            this.addParam.payeeBankName = ''
            this.addParam.payeeAccount = ''
            this.addParam.payeeAddress = ''
          }
        },
        deep: true
      },
      addData: {
        handler(n) {
          this.addSum = 0;
          n.forEach(ele => {
            if (ele.levelId) {
              this.addSum += ele.insuranceAmount;
            }
          })
        },
        deep: true
      }
    },
    methods: {
      refresh() {
        let data = this.filter;
        data.pageNo = this.currentPage;
        data.pageSize = this.pageSize;
        data.contractType = 1;
        this.$global.axios.post(this, '/sywl/api/insuranceInfo/list', data, res => {
          this.tableData = res.data.records;
        })
      },
      insurance1Change(e) {
        if (this.addData.length !== 0) {
          this.$confirm('此操作将清空被保人表格内数据，是否继续？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(() => {
            this.insuranceChange(e)
          }).catch(() => {
            this.addParam.insuranceId1 = this.addParam.insuranceId;
          })
        } else {
          this.insuranceChange(e)
        }
      },
      insuranceChange(e) {
        this.addParam.insuranceId = e;
        this.addData.forEach((ele, index) => {
          this.addData[index].levelId = ''
          this.levelChange(index)
        })
        this.$global.axios.post(this, '/sywl/api/levelList', {
          insuranceId: this.addParam.insuranceId
        }, res => {
          this.levelList = res.data;
        })
      },
      levelChange(index) {
        let obj = this.addData[index];
        try {
          this.levelList.forEach((ele, index) => {
            if (ele.levelId === obj.levelId) {
              obj.insuranceAmount = ele.insuranceAmount;
              obj.guaranteeAmount = ele.guaranteeAmount;
              obj.levelName = ele.levelName;
              throw Error()
            } else if (index === this.levelList.length - 1) {
              delete obj.insuranceAmount
              delete obj.guaranteeAmount
              delete obj.levelName
            }
          })
        } catch (info) {}
        this.addData[index] = obj;
      },
      recognizeeRefresh() {
        this.$global.axios.post(this, '/sywl/api/insuranceInfo/detail', {
          insureId: this.addParam.insureId
        }, res => {
          this.addData = res.data
          this.addDefaultData = res.data
        })
      },
      pageChange(t) {
        this.currentPage = t;
        this.refresh();
      },
       handleSizeChange(n) {
        this.pageSize= n;
        this.refresh();
      },
      onSubmit() {
        this.currentPage = 1;
        this.refresh();
      },
      openEdit(row) {
        this.isUpdate = row.insuranceId ? true : false
        if (this.isUpdate) {
          for (let key in this.addParam) {
            this.addParam[key] = row[key]
          }
          this.addParam.insuranceId1 = row.insuranceId
          this.addParam.insuranceId = row.insuranceId
          this.insuranceChange(row.insuranceId)
        }
        this.addShow = true
      },
      addClose() {
        this.addShow = false
      },
      downloadMode() {
        window.open('/static/others/保单被保人信息.xlsx')
      },
      recognizeeImp(file) {
        if (this.addParam.insuranceId) {
          let fileReader = new FileReader()
          fileReader.onload = ev => {
            try {
              let data = ev.target.result,
                workbook = XLSX.read(data, {
                  type: 'binary'
                }), // 以二进制流方式读取得到整份excel表格对象
                persons = []; // 存储获取到的数据
              // 表格的表格范围，可用于判断表头是否数量是否正确
              let fromTo = '';
              // 遍历每张表读取
              for (let sheet in workbook.Sheets) {
                if (workbook.Sheets.hasOwnProperty(sheet)) {
                  fromTo = workbook.Sheets[sheet]['!ref'];
                  console.log(fromTo);
                  persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                  break; // 如果只取第一张表，就取消注释这行
                }
              }
              persons.forEach(ele => {
                let levelId = '',
                  insuranceAmount = '';
                this.levelList.forEach(ele1 => {
                  if (ele1.levelName === ele['*职位'] && ele1.guaranteeAmount === ele['*保障金额']) {
                    levelId = ele1.levelId;
                    insuranceAmount = ele1.insuranceAmount;
                  }
                })
                this.addData.push({
                  insuredName: ele['*被保人'],
                  insuredPhone: ele['*被保人手机号码'],
                  insuredCard: ele['*被保人证件号'],
                  levelId: levelId,
                  insuranceAmount: insuranceAmount,
                  guaranteeAmount: ele['*保障金额']
                })
              })
            } catch (e) {
              this.$message.error('文件类型不正确');
              return;
            }
          }
          fileReader.readAsBinaryString(file)
        } else {
          this.$message.warning('请先选择保险');
        }
      },
      recognizeeEdit(row) {
        if (row) {
          this.$global.axios.post(this, '/sywl/api/insuranceInfo/update', {
            jsonStr: JSON.stringify(Object.assign(row, {
              insuranceId: this.addParam.insuranceId
            }))
          }, async res1 => {
            this.$message.success('操作成功')
            this.addClose()
            this.recognizeeRefresh()
          })
        } else {
          if (this.addParam.insuranceId) {
            this.addData.unshift({})
          } else {
            this.$message.warning('请先选择保险');
          }
        }
      },
      recognizeeDelete(ind) {
        this.addData.splice(ind, 1)
      },
      save() {
        this.$refs['add'].validate(valid => {
          if (valid) {
            if (this.addData.length == 0) {
              this.$message.error('被保人信息不能为空');
            } else {
              let data = new Object();
              for (let key in this.addParam) {
                if (key.indexOf('Date') !== -1) {
                  data[key] = this.$global.format(this.addParam[key], 'yyyy-MM-dd');
                } else {
                  data[key] = this.addParam[key];
                }
              }
              if (!this.isUpdate) data.dtoList = this.addData;
              else {
                data = Object.assign(data, this.addData[0])
              }
              this.$global.axios.post(this, '/sywl/api/insuranceInfo/add', {
                jsonStr: JSON.stringify(data)
              }, async res1 => {
                if (this.addParam.payType != 1) {
                  this.$global.goPay(this, res1.data, res => {
                    this.$message.success('操作成功')
                    this.addClose()
                    this.refresh()
                  })
                } else {
                  this.$message.success('操作成功')
                  this.addClose()
                  this.refresh()
                }
              })
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add {
    padding: 12px 16px;
    background-color: #fff;

    & /deep/ .el-dialog__header {
      background-color: #000;
      text-align: left;
      color: #fff;

      .el-dialog__title {
        color: #fff;
      }
    }

    & /deep/ .el-dialog__body {
      padding: 20px;

      .el-form {
        text-align: left;

        .el-select {
          width: calc(100% - 13px);
        }

        .el-date-editor--date {
          display: inline-block;
          width: calc(100% - 13px);
        }
      }
    }

    &Head {
      .el-button {
        margin-bottom: 20px;
        border-color: #1875f0;
        color: #1875f0;
      }
    }

    .el-form {
      text-align: left;
    }

    & /deep/ .el-table {
      .el-table__cell {
        font-size: 12px;
        text-align: center;
      }
    }

    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/insurance.vue